import React from "react";
import {
  List,
  AppBar,
  Typography,
  Tabs,
  Tab,
  Divider,
  Fab,
  Box,
  Container,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useAuth } from "../contexts/AuthContext";
import firebase from 'firebase/app'
import "firebase/firestore"
import Branding from "./Branding";
import ChatListItems from "./ChatListItems";
import DotMenu from "./DotMenu";
import { Message as MessageIcon } from "@material-ui/icons";
import { AddChatDialog } from "./AddChatDialog";
import { useAddChatDialog } from "../contexts/AddChatDialogContext";
import NoChatBanner from "./NoChatBanner";

const useStyles = makeStyles((theme) => ({
  fabButton: {
    position: "fixed",
    zIndex: 1,
    top: "auto",
    bottom: 20,
    left: "auto",
    right: "10%",
    // margin: '0 auto',
  },
}));

const db = firebase.firestore();

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      style={{ marginTop: "100px" }}
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function MobileHome() {
  const { currentUser } = useAuth();
  const [chats, setChatList] = React.useState([]);

  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { dialogOpen, setDialogOpen } = useAddChatDialog();
  

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const fetchChats = () => {
    db.collection("rooms")
      .where("participents", "array-contains", currentUser.uid)
      .onSnapshot((querySnapshot) => {
        const chats = [];
        querySnapshot.forEach((doc) => {
          chats.push(doc.data());
        });

        setChatList(chats);
      });
  };

  React.useEffect(() => {
    fetchChats();
  }, []);

  return (
    <Box>
      <AppBar position="fixed">
        <Branding>
          <DotMenu color="white" />
        </Branding>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="fullWidth"
          aria-label="simple tabs example"
        >
          <Tab label="Chats" />
          <Tab disabled label="Contacts" />
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        {chats ? (
          <>
            <List>
              {chats.map((chat, index) => (
                <ChatListItems
                  chat={chat}
                  Key={index}
                  info={chat.participents.length + " participents"}
                />
              ))}
            </List>

            <div className={classes.fabButton}>
              <Fab
                aria-describedby="chat-popover"
                onClick={(e) => setDialogOpen(true)}
                size="large"
                color="secondary"
                aria-label="add"
              >
                <MessageIcon />
              </Fab>
            </div>
            <AddChatDialog open={dialogOpen} />

            <Container>
              <Divider />
              <Typography variant="subtitle2">
                this mobile web app is in development.
              </Typography>
            </Container>
          </>
        ) : (
          <NoChatBanner />
        )}
      </TabPanel>
      <TabPanel style={{ marginTop: "100px" }} value={value} index={1}>
        <Container>
          <Typography>[contacs will go here]</Typography>
        </Container>
      </TabPanel>
    </Box>
  );
}

export default MobileHome;
